import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";
import { MapLeaflet } from "../common/mapLeaflet/MapLeaflet";
import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import ContentCardFooter from "../common/template/contentCardFooter";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInput from "../common/form/labelAndInput";
import LabelAndInputNumber from "../common/form/labelAndInputNumber";
import Select from "../common/form/select";
import { filtrarUcPorDataDesligamento } from "../utils/filtrarUcPorDataDesligamento";
import THead from "../common/table/tHead";
import Table from "../common/table/table";
import Tr from "../common/table/tr";
import Td from "../common/table/td";
import TBody from "../common/table/tBody";
import Th from "../common/table/th";
import { setModoTela, initForm } from "./consumoIntegracaoActions";
import { useState } from "react";
import { setError } from "../common/toast/toast";
import ButtonTable from "../common/table/buttonTable";

function ConsumoIntegracaoForm(props) {
    const [medidorForm, setMedidorForm] = useState(null);
    const [itemAlteracao, setItemAlteracao] = useState(null);

    const readOnly = !!(props.excluir || props.visualizar || medidorForm);

    const links = {
        1: "https://hdm.hdeletro.com.br", //HD
        2: "https://datalog.issodns.com",
        3: "",
        4: "http://smf.coprel.com.br:9596/hemera/loginHemera.jsp", //HEMERA
        5: "",
    };

    return (
        <>
            <ContentCard>
                <Form event={props.handleSubmit}>
                    <Row>
                        <Grid cols="12 12 6 6">
                            <ContentCardBody>
                                <Row>
                                    <Select
                                        cols="12 12 12 12"
                                        name="id_cliente"
                                        //se usuario implantacao estiver logado
                                        //filtra para poder incluir apenas itens na UC
                                        //que ele é o implantador
                                        options={
                                            props.usuarioLogado.usuario_implantacao
                                                ? props.listaCliente.filter((cliente) => cliente.itens.find((uc) => uc.id_usuario_implantacao == props.usuarioLogado.id))
                                                : props.listaCliente
                                        }
                                        label="Cliente"
                                        placeholder="Selecione o Cliente"
                                        value={props.formularioValues.id_cliente}
                                        onChange={(value) => {
                                            props.initForm({
                                                ...props.formularioValues,
                                                id_cliente: value,
                                            });
                                        }}
                                        readOnly={readOnly}
                                    />
                                </Row>
                                <Row>
                                    <Select
                                        cols="12 12 12 12"
                                        name="id_unidade_consumidora"
                                        //se usuario implantacao estiver logado
                                        //filtra para poder incluir apenas itens na UC
                                        //que ele é o implantador
                                        options={props.listaUnidadeConsumidora.filter((item) => {
                                            const implantacaoLogado = props.usuarioLogado.usuario_implantacao;
                                            const ucClienteSelecionado = item.id_cliente == props.formularioValues.id_cliente;
                                            if (implantacaoLogado) {
                                                const usuarioImplantacaoVinculadoUc = item.id_usuario_implantacao == props.usuarioLogado.id;
                                                return usuarioImplantacaoVinculadoUc && ucClienteSelecionado;
                                            }
                                            return ucClienteSelecionado;
                                        })}
                                        label="Unidade Consumidora"
                                        placeholder="Selecione a UC"
                                        value={props.formularioValues.id_unidade_consumidora}
                                        onChange={(value) => {
                                            props.initForm({
                                                ...props.formularioValues,
                                                id_unidade_consumidora: value,
                                            });
                                        }}
                                        readOnly={readOnly}
                                    />
                                </Row>
                                {props.formularioValues.id_consumo_integracao_tipo && links[props.formularioValues.id_consumo_integracao_tipo] ? (
                                    <Row>
                                        <b className="ml-2 mb-3 mr-1">Link para login na plataforma do fabricante:</b>

                                        <a href={links[props.formularioValues.id_consumo_integracao_tipo]} target="_blank" rel="noopener noreferrer">
                                            {links[props.formularioValues.id_consumo_integracao_tipo]}
                                        </a>
                                    </Row>
                                ) : null}
                                <Row>
                                    <Field
                                        name="id_consumo_integracao_tipo"
                                        cols="12 12 12 12"
                                        component={Select}
                                        options={props.listaConsumoIntegracaoTipos}
                                        label="Tipo"
                                        placeholder="Informe o tipo da integração"
                                        readOnly={readOnly}
                                    />
                                </Row>
                                {props.formularioValues.id_consumo_integracao_tipo == 5 ? (
                                    <Row>
                                        <Field
                                            name="constante_medidor"
                                            component={LabelAndInputNumber}
                                            label="Constante do Medidor"
                                            placeholder="Informe a constante do medidor"
                                            cols="12 12 12 12"
                                            casas={6}
                                            readOnly={readOnly}
                                        />
                                        {medidorForm ? (
                                            <>
                                                <LabelAndInput
                                                    name="numero_medidor"
                                                    label="Número do Medidor"
                                                    placeholder="Informe Nº Série"
                                                    cols="12 4 4 4"
                                                    value={medidorForm.numero_serie}
                                                    onChange={(e) => {
                                                        setMedidorForm({
                                                            ...medidorForm,
                                                            numero_serie: e.target.value,
                                                        });
                                                    }}
                                                />
                                                <Select
                                                    name="modelo"
                                                    options={[{ id: "iG9KCEL", valor: "iG9KCEL" }]}
                                                    label="Modelo"
                                                    cols="12 4 4 4"
                                                    placeholder="Informe o Modelo"
                                                    value={medidorForm.modelo}
                                                    onChange={(value) => {
                                                        setMedidorForm({
                                                            ...medidorForm,
                                                            modelo: value,
                                                        });
                                                    }}
                                                />
                                                <Grid cols="6 2 2 2">
                                                    <Button
                                                        style={{ marginTop: 28 }}
                                                        solid={true}
                                                        icon={`fas fa-check`}
                                                        type={"success"}
                                                        event={() => {
                                                            if (!medidorForm.numero_serie) {
                                                                setError("Informe o número do medidor para poder incluir");
                                                                return;
                                                            }
                                                            if (!medidorForm.modelo) {
                                                                setError("Informe o modelo do medidor para poder incluir");
                                                                return;
                                                            }
                                                            const medidores = [...props.formularioValues.medidores].filter((item) => {
                                                                return !itemAlteracao || JSON.stringify(itemAlteracao) !== JSON.stringify(item); //se ta alterando remove o alterado da lista para incluir atualizado
                                                            });

                                                            medidores.push(medidorForm);
                                                            props.initForm({
                                                                ...props.formularioValues,
                                                                medidores,
                                                            });
                                                            setMedidorForm();
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid cols="6 2 2 2">
                                                    <Button
                                                        style={{ marginTop: 28 }}
                                                        solid={true}
                                                        icon={`fas fa-times`}
                                                        type={"danger"}
                                                        event={() => {
                                                            setMedidorForm();
                                                        }}
                                                    />
                                                </Grid>
                                            </>
                                        ) : (
                                            <Grid cols="12 12 12 12">
                                                <Button
                                                    style={{ margin: 0 }}
                                                    disabled={readOnly}
                                                    text="Adicionar Medidor"
                                                    type={"success"}
                                                    icon={"fa fa-plus"}
                                                    event={() => setMedidorForm({})}
                                                />
                                            </Grid>
                                        )}
                                        {props.formularioValues.medidores.length ? (
                                            <Grid cols="12 12 12 12" style={{ marginBottom: 30 }}>
                                                <Table responsive tableBorder="1px solid #DDD">
                                                    <THead>
                                                        <Tr>
                                                            <Th style={{ fontSize: "0.9rem" }} alignCenter>
                                                                Número de Série
                                                            </Th>
                                                            <Th style={{ fontSize: "0.9rem" }} alignCenter>
                                                                Modelo
                                                            </Th>
                                                            <Th style={{ fontSize: "0.9rem" }}></Th>
                                                        </Tr>
                                                    </THead>
                                                    <TBody>
                                                        {props.formularioValues.medidores
                                                            .filter((item) => !item.id || item.ativo) //exibe apenas os sem id (novos), ou ativos (oculta os excluidos agora)
                                                            .map((item, i) => {
                                                                return (
                                                                    <Tr key={`${item.id}-${item.numero_serie}-${item.modelo}`}>
                                                                        <Td fontSize={"0.9rem"} alignCenter>
                                                                            {item.numero_serie}
                                                                        </Td>
                                                                        <Td fontSize={"0.9rem"} alignCenter>
                                                                            {item.modelo}
                                                                        </Td>
                                                                        <Td fontSize={"0.9rem"} alignRight>
                                                                            <ButtonTable
                                                                                visible={!readOnly}
                                                                                type={"warning"}
                                                                                icon={"fa fa-pencil-alt"}
                                                                                event={() => {
                                                                                    setItemAlteracao({ ...item });
                                                                                    setMedidorForm({ ...item });
                                                                                }}
                                                                            />
                                                                            <ButtonTable
                                                                                visible={!readOnly}
                                                                                type={"danger"}
                                                                                icon={"fa fa-trash-alt"}
                                                                                event={() => {
                                                                                     if (!window.confirm("Deseja realmente excluir o medidor?")) return;
                                                                                    let medidores = [...props.formularioValues.medidores];

                                                                                    if (item.id) {
                                                                                        //altera ativo pra false
                                                                                        medidores = medidores.map((m) => (m.id == item.id ? { ...m, ativo: false } : m));
                                                                                    } else {
                                                                                        //tira o item clicado da lista
                                                                                        medidores = medidores.filter(
                                                                                            (m) => m.numero_serie !== item.numero_serie && m.modelo !== item.modelo
                                                                                        );
                                                                                    }
                                                                                    props.initForm({
                                                                                        ...props.formularioValues,
                                                                                        medidores,
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </Td>
                                                                    </Tr>
                                                                );
                                                            })}
                                                    </TBody>
                                                </Table>
                                            </Grid>
                                        ) : null}
                                    </Row>
                                ) : props.formularioValues.id_consumo_integracao_tipo == 2 ? (
                                    <Field
                                        cols="12 12 12 12"
                                        name="link"
                                        component={LabelAndInput}
                                        label="Link de Acesso"
                                        placeholder="Informe o link de acesso"
                                        readOnly={readOnly}
                                    />
                                ) : (
                                    <>
                                        {props.formularioValues.id_consumo_integracao_tipo == 4 ? (
                                            <Row>
                                                <Field
                                                    cols="12 12 12 12"
                                                    name="numero_medidor"
                                                    component={LabelAndInput}
                                                    label="Número do medidor"
                                                    placeholder="Informe o número do medidor"
                                                    readOnly={readOnly}
                                                />
                                            </Row>
                                        ) : null}
                                        <Row>
                                            <Field
                                                cols="12 12 12 12"
                                                name="usuario"
                                                component={LabelAndInput}
                                                label="Usuário Integração"
                                                placeholder="Informe o nome de usuário da integração"
                                                readOnly={readOnly}
                                            />
                                        </Row>
                                        <Row>
                                            <Field
                                                cols="12 12 12 12"
                                                name="senha"
                                                component={LabelAndInput}
                                                label="Senha Integração"
                                                placeholder="Informe a senha do usuário da integração"
                                                readOnly={readOnly}
                                            />
                                        </Row>
                                    </>
                                )}
                            </ContentCardBody>
                        </Grid>
                        <Grid cols="12 12 6 6">
                            <div style={{ padding: "13px 5px 5px 0px" }}>
                                <b>Coordenadas</b>
                            </div>
                            <div style={{ width: "98%", height: 450 }}>
                                <MapLeaflet
                                    getCurrentPosition={!props.formularioValues.id}
                                    latitude={props.formularioValues.latitude}
                                    longitude={props.formularioValues.longitude}
                                    onChange={(coordenadas) => {
                                        props.initForm({
                                            ...props.formularioValues,
                                            latitude: String(coordenadas.latitude).substring(0, 15),
                                            longitude: String(coordenadas.longitude).substring(0, 15),
                                        });
                                    }}
                                />
                            </div>
                        </Grid>
                    </Row>
                    <ContentCardFooter>
                        <Row alignCenter>
                            <Grid cols="6 6 4 3">
                                {props.excluir ? (
                                    <Button text="Excluir" submit type={"danger"} icon={"fa fa-trash"} disabled={props.visualizar} />
                                ) : (
                                    <Button text={"Salvar"} submit type={"success"} icon={"fa fa-check"} disabled={props.visualizar || medidorForm} />
                                )}
                            </Grid>
                            <Grid cols="6 6 4 3">
                                <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => props.setModoTela("lista")} />
                            </Grid>
                        </Row>
                    </ContentCardFooter>
                </Form>
            </ContentCard>
        </>
    );
}

const ConsumoIntegracaoFormRedux = reduxForm({ form: "consumoIntegracaoForm", destroyOnUnmount: false })(ConsumoIntegracaoForm);
const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    formularioValues: getFormValues("consumoIntegracaoForm")(state),
    registro: state.consumoIntegracao.registro,
    filtro: state.consumoIntegracao.filtro,
    lista: state.consumoIntegracao.lista,
    listaConsumoIntegracaoTipos: state.consumoIntegracao.listaConsumoIntegracaoTipos,
    listaCliente: state.consumoIntegracao.listaCliente,
    listaUnidadeConsumidora: filtrarUcPorDataDesligamento(state.consumoIntegracao.listaUnidadeConsumidora),
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(ConsumoIntegracaoFormRedux);
